
import { createAsyncAction } from 'react-async-client';

import * as actions from '../constants/actionTypes';
import * as handlers from './handlers';

export const postOPD = createAsyncAction(actions.POST_OPD, handlers.postOPDHandler);
export const postCancelOPD = createAsyncAction(actions.POST_CANCEL_OPD, handlers.postCancelOpdHandler);

export const getUserLink = createAsyncAction(actions.GET_USERLINK, handlers.getUserLinkHandler);
